<template>
  <div>
    <v-container grid-list-xs>
      <v-card width="350" color="deep-purple darken-4" class="mx-auto" dark>
        <v-card-title primary-title>
          <h2> Descargar Tabla:</h2>

        </v-card-title>
        <v-card-title  second-title>
          <v-icon medium right :color="color_carpeta">folder</v-icon>
          <h3> {{nombre_operativo}}</h3>
          <v-spacer></v-spacer>

          <v-progress-circular
            v-if="!boton_activo"
            indeterminate
            color="primary"
          ></v-progress-circular>
          <v-icon v-else large :color="color_carpeta">done</v-icon>
        </v-card-title>

        <v-card-text>
          <download-csv
            :data="dataVals"
            :name="csvname + '.csv'"
            :labels="labels"
            :fields="fields"
            >
            <div class="text-xs-center">
              <v-btn color="success" :disabled="!boton_activo" class="mx-auto">
                <v-icon style="vertical-align: middle" left>cloud_download</v-icon>csv
              </v-btn>
            </div>
          </download-csv>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>

<script>
// import chartLine from '@/components/Charts/LineBase'
// import dataTable from '@/components/Tables/TableBaseCovid'
import JsonCSV from 'vue-json-csv'

export default {

  name: 'Descargar Tabla',
  components: {
    // 'chart-line': chartLine,
    // 'data-table': dataTable,
    'download-csv': JsonCSV
  },
  data () {
    return {
      backConf: {
        path: '/projects/stat_data/'
      },
      operativo: null,
      datos: null,
      search: null,

      boton_activo: false,
      color_carpeta: 'white',

      // variables para saber por medio de peticion
      // si aplica o no reportes de cada tipo.
      nombre_operativo: null,
      mensaje: null,
      csvname: '',
      dataVals: null,
      labels: null,
      fields: null
    }
  },

  watch: {
    '$store.state.actualOperation': function () {
      this.operativo = this.$store.state.actualOperation.id
    }
  },

  created () {
    this.$store.commit('SET_LAYOUT', 'dashboard-layout')
    this.operativo = this.$store.state.actualOperation.id

    this.nombre_operativo = this.$store.state.actualOperation.nombre_operativo
    let a = this.nombre_operativo.replace('/', '_')
    let b = a.replace(' ', '_')
    // console.log(this.$store.state.actualOperation);
    this.csvname = 'Tabla_' + b
    this.getTabla()
  },

  methods: {
    getTabla () {
      this.loading = true
      this.data = null
      let request = {
        method: 'get',
        url: this.backConf.path,
        params: {
          operativo: this.operativo
        }
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.dataVals = resp.data.rows
          t.labels = resp.data.fields
          t.fields = resp.data.fields
          t.boton_activo = true
          t.color_carpeta = 'green'
        })
        .catch(err => console.error(err))
    }

  }
}
</script>
